import { clearWebStorage } from './webStorage';
import { clearInMemoryData } from '../services/dataProvider';

function clearSupportChatData(): void {
    clearWebStorage();
    clearInMemoryData();
}

export { clearSupportChatData };
